import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { onCLS, onFCP, onFID, onINP, onLCP, onTTFB } from 'web-vitals/attribution';

function initWebVitals() {
    const config = getConfig();
    const telemetry = getTelemetry();
    const httpApi = getHttpApi();
    const isEnabled = config.get('web.browser.vitals.enabled');
    if (!isEnabled) {
        return;
    }
    const transport = config.getStrict('web.browser.vitals.transport');
    const metricsPathApi = config.getStrict('web.browser.vitals.pathApi');
    const metricsMicroserviceName = config.getStrict('web.browser.vitals.microserviceName');
    const logTelemetry = config.get('web.browser.vitals.log');
    const deviceType = config.getStrict('web.deviceType');
    const microserviceName = config.getStrict('projectName');
    const url = window.location.href;
    function handler(metric) {
        const { name, value, rating, delta, id } = metric;
        let debugTarget;
        switch (metric.name) {
            case 'CLS':
                debugTarget = metric.attribution.largestShiftTarget;
                break;
            case 'FID':
            case 'INP':
                debugTarget = metric.attribution.eventTarget;
                break;
            case 'LCP':
                debugTarget = metric.attribution.element;
                break;
        }
        if (transport === 'telemetry') {
            telemetry.timer(`frontend-metrics.${deviceType}.${name}`, value);
            return;
        }
        httpApi
            .fetch({
            microserviceName: metricsMicroserviceName,
            pathApi: metricsPathApi,
            assertStatusCodes: [200, 400],
            method: 'POST',
            parameters: {
                debugTarget,
                delta,
                deviceType,
                id,
                microserviceName,
                rating,
                url,
                [name]: value,
            },
            responseType: 'json',
        })
            .then(res => {
            if (!logTelemetry) {
                return;
            }
            const keyPart = res.statusCode === 200 ? 'success' : 'miss';
            telemetry.increment(`frontend-metrics.${deviceType}.${keyPart}`);
        })
            .catch(err => {
            getLogger().error(err);
        });
    }
    onCLS(handler);
    onFCP(handler);
    onFID(handler);
    onINP(handler);
    onLCP(handler);
    onTTFB(handler);
}

export { initWebVitals };
//# sourceMappingURL=vitals.mjs.map
